// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://54.38.33.249:3000/',
  apiUrl: 'https://api-prod.tropikvtc.fr/',
  // apiUrl: 'http://localhost:3000/',
  defaultHttpHeader: { 'content-Type': 'application/json' }
};

/*
 * For easier debugging in development mode, you can import the followin     g file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
